// Tasks list
export const ADJUSTMENT_TASK = "adjustment"
export const INACTIVE_PROMOTION_TASK = "inactive_promotion"
export const MISSING_AT_LOCATION_TASK = "missing_at_location"
export const MISSING_IN_STORE_TASK = "missing_in_store"
export const MISSING_PROMOTION_TASK = "missing_promotion"
export const OVERHEAD_TASK = "overhead"

// Values of `overhead_freshness.state` as sent by the API.
export const OVERHEAD_FRESHNESS_STATES = {
  missing: "missing",
  fresh: "fresh",
  stale: "stale",
}
export const PRICE_MISMATCH_TASK = "price_mismatch"
// TODO: Remove PRICE_DIFFERENCE_TASK and resolveLegacyTaskType once api-tasks
// stops returning `price_difference`.
export const PRICE_DIFFERENCE_TASK = "price_difference"
export const STOCKOUT_TASK = "stockout"
export const UNEXPECTED_LOCATION_TASK = "unexpected_location"
export const UNIMPLEMENTED_TASK = "unimplemented"
export const ZERO_STOCK_TASK = "zero_stock"

/**
 * Maps the legacy price task type onto its canonical name.
 *
 * Resolve the value before comparing it or building a translation key. Never
 * resolve what goes back to api-tasks: outgoing requests echo the task type the
 * API sent, so they keep matching whichever name it is using.
 *
 * @param {string} taskType - Task type as it arrived from the API.
 * @returns {string} The canonical name, or the same value when it is not legacy.
 */
export const resolveLegacyTaskType = (taskType) =>
  taskType === PRICE_DIFFERENCE_TASK
    ? PRICE_MISMATCH_TASK
    : taskType

// Price types
// A shelf label can carry several prices. The field is treated as open-ended —
// only the default is named, so a new type added upstream still renders.
export const REGULAR_PRICE_TYPE = "regular"
